/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES 企業の管理画面用 API
 * PR TIMES 企業の管理画面で使うAPI。basePathは今後変わる事も想定している。
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { PressKitPresignedUrl } from './PressKitPresignedUrl';
import {
    PressKitPresignedUrlFromJSON,
    PressKitPresignedUrlFromJSONTyped,
    PressKitPresignedUrlToJSON,
} from './PressKitPresignedUrl';

/**
 * POST /press_kit/s3_put_presigned_url
 * @export
 * @interface GetS3PutPresignedUrlResponse
 */
export interface GetS3PutPresignedUrlResponse {
    /**
     * status code (HTTPと同じ)
     * @type {number}
     * @memberof GetS3PutPresignedUrlResponse
     */
    status: number;
    /**
     * ステータスメッセージ。原則英語。
     * @type {string}
     * @memberof GetS3PutPresignedUrlResponse
     */
    message: string;
    /**
     * 
     * @type {PressKitPresignedUrl}
     * @memberof GetS3PutPresignedUrlResponse
     */
    data: PressKitPresignedUrl;
}

/**
 * Check if a given object implements the GetS3PutPresignedUrlResponse interface.
 */
export function instanceOfGetS3PutPresignedUrlResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "status" in value;
    isInstance = isInstance && "message" in value;
    isInstance = isInstance && "data" in value;

    return isInstance;
}

export function GetS3PutPresignedUrlResponseFromJSON(json: any): GetS3PutPresignedUrlResponse {
    return GetS3PutPresignedUrlResponseFromJSONTyped(json, false);
}

export function GetS3PutPresignedUrlResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetS3PutPresignedUrlResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'status': json['status'],
        'message': json['message'],
        'data': PressKitPresignedUrlFromJSON(json['data']),
    };
}

export function GetS3PutPresignedUrlResponseToJSON(value?: GetS3PutPresignedUrlResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'status': value.status,
        'message': value.message,
        'data': PressKitPresignedUrlToJSON(value.data),
    };
}

